let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fXVMa")).then(() => parcelRequire('3TOuk'));